export const SALADES_PHOTOS = [
  '/photos/salades/s-17.jpg',
  '/photos/salades/s-2-smoothies.jpg',
  '/photos/salades/s-img-20230515-113311-01-01.jpg',
  '/photos/salades/s-my-post-1.jpg',
  '/photos/salades/s-sans-titre.jpg',
  '/photos/salades/s-whatsapp-image-2025-02-19-at-16-05-10.jpg',
  '/photos/salades/s-whatsapp-image-2025-02-19-at-16-05-14.jpg',
  '/photos/salades/s-whatsapp-image-2025-02-19-at-16-05-19.jpg',
  '/photos/salades/s-whatsapp-image-2025-02-19-at-16-05-31.jpg',
  '/photos/salades/s-bar.jpg',
  '/photos/salades/s-byatj8g1-10102025-140056.jpg',
  '/photos/salades/s-chevre-miel.jpg',
  '/photos/salades/s-cookies-general.jpg',
  '/photos/salades/s-equilibre.jpg',
  '/photos/salades/s-fraise-framboise.jpg',
  '/photos/salades/s-from.jpg',
  '/photos/salades/s-g6ejco14-10102025-140008.jpg',
  '/photos/salades/s-grainette.jpg',
  '/photos/salades/s-grande-salade-de-fruits-melanges.jpg',
  '/photos/salades/s-grecque.jpg',
  '/photos/salades/s-ia0eh0su-10102025-140232.jpg',
  '/photos/salades/s-italienne.jpg',
  '/photos/salades/s-mangue-kiwi.jpg',
  '/photos/salades/s-mexicaine.jpg',
  '/photos/salades/s-mediteraneenne.jpg',
  '/photos/salades/s-poke-grainette.jpg',
  '/photos/salades/s-salade-ju.jpg',
  '/photos/salades/s-salle.jpg',
];

export const PATES_PHOTOS = [
  '/photos/pates/p-27cfcc-copie.jpg',
  '/photos/pates/p-3a3432-copie.jpg',
  '/photos/pates/p-5690e7.jpg',
  '/photos/pates/p-cookie-min.jpg',
  '/photos/pates/p-fruits-min-copie.jpg',
  '/photos/pates/p-img-0432-copie.jpg',
  '/photos/pates/p-img-0439-copie.jpg',
  '/photos/pates/p-img-0486-copie.jpg',
  '/photos/pates/p-img-0499-copie.jpg',
  '/photos/pates/p-img-0510-copie.jpg',
  '/photos/pates/p-img-20230627-143333-2.jpg',
  '/photos/pates/p-my-project-1-2.jpg',
  '/photos/pates/p-my-project-1-3.jpg',
  '/photos/pates/p-panna-cotta-min-copie.jpg',
  '/photos/pates/p-pistache-min-copie.jpg',
  '/photos/pates/p-sans-titre.jpg',
  '/photos/pates/p-whatsapp-image-2025-02-11-a-12-00-12-9dcdbf56-copi.jpg',
  '/photos/pates/p-whatsapp-image-2025-02-19-at-16-05-12.jpg',
  '/photos/pates/p-whatsapp-image-2025-02-19-at-16-05-13.jpg',
  '/photos/pates/p-whatsapp-image-2025-02-19-at-16-05-14.jpg',
  '/photos/pates/p-whatsapp-image-2025-02-19-at-16-05-21.jpg',
  '/photos/pates/p-whatsapp-image-2025-02-19-at-16-47-29.jpg',
  '/photos/pates/p-restau.jpg',
];

export function shuffleMix(n = 6) {
  const all = [
    ...SALADES_PHOTOS.map(s => ({ src: s, type: 'salade' })),
    ...PATES_PHOTOS.map(s => ({ src: s, type: 'pate' })),
  ];
  for (let i = all.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [all[i], all[j]] = [all[j], all[i]];
  }
  return all.slice(0, n);
}
